import * as XLSX from 'xlsx';
import createKeyMap from './createKeyMap';
import timeFormAPI from '../ui/timeFormAPI';

const excelDownload = (fileName, excelData, sortKey) => {
  const worksheet = XLSX.utils.json_to_sheet([]);
  const { headers, keyMap } = createKeyMap(excelData, fileName, sortKey);

  // A1부터 시작하도록 헤더 추가
  XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' });

  // 데이터 추가
  excelData.forEach((data, index) => {
    const rowData = headers.map((header) => {
      const keys = keyMap[header].split('.');
      let value = data;
      for (const key of keys) {
        if (key === 'targetDate' || key === 'date') {
          value = timeFormAPI.changeDataDate(value[key]);
        } else {
          value = value[key] || 0;
        }
      }
      return value;
    });
    XLSX.utils.sheet_add_aoa(worksheet, [rowData], { origin: `A${index + 2}` });
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export default excelDownload;
